/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ItemWrap } from '@/components/layouts/ItemWrap';
import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { layoutGridHeightSX } from '@/components/layouts/styles/gridHeight';
import { layoutFooterSX, layoutMainSX } from '@/components/layouts/styles/main';
import { layoutStackHeightSX } from '@/components/layouts/styles/stackHeight';
import { useLocalization } from '@/data/Localization';
import { Layout } from '@/data/types/Layout';
import { Container, Grid, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';

export const AsideExtendedPlp: FC<{ layout: Layout }> = ({ layout }) => {
	const {
		dimensions: { contentSpacing },
		customDimensions: { layoutSpacing },
	} = useTheme();
	const { Labels : productFilterLables } = useLocalization('ProductFilter');
	return layout ? (
		<>
			<LayoutSlot slot={layout.slots.header} />
			<Stack
				id="main-content"
				direction="column"
				component="main"
				spacing={layoutSpacing}
				sx={layoutMainSX(layout.slots.first?.length || 0)}
			>
				<Grid item xs="auto">
					<LayoutSlot slot={layout.slots.first} ItemWrap={ItemWrap} />
				</Grid>
				<Grid item xs>
					<Container component="section" sx={layoutStackHeightSX}>
						<Grid container spacing={contentSpacing} sx={layoutStackHeightSX}>
							<Grid
								item
								component="aside"
								xs={12}
								sm={4} 
								md={3}
								aria-label={productFilterLables.ariaLabel.t()}
							>
								<Stack gap={layoutSpacing}>
									<LayoutSlot slot={layout.slots.aside} />
								</Stack>
							</Grid>
							<Grid item component="section" xs={12} sm={8} md={9} sx={layoutGridHeightSX}>
								<Stack gap={layoutSpacing} sx={layoutStackHeightSX}>
									<LayoutSlot slot={layout.slots.second} />
								</Stack>
							</Grid>
						</Grid>
					</Container>
				</Grid>
			</Stack>
			<Grid item xs="auto" sx={layoutFooterSX}>
				<LayoutSlot slot={layout.slots.footer} />
			</Grid>
		</>
	) : null;
};
